/* Main File */
(function($) {

  'use strict';

  const BASE_API = $('[rel="https://api.w.org/"]').attr('href') + 'wp/v2';
  const BASE_URL = $('body').data('baseurl');
  const phoneMask = (val) => val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
  const maskOptions = {
    onKeyPress: function(val, e, field, options) {
      field.mask(phoneMask.apply({}, arguments), options);
    }
  };

  function isMobile(offset) {
    offset = typeof offset !== 'undefined' ? offset : 1009;

    return $(window).width() < offset;
  }

  function initMap(location) {
    let map = new google.maps.Map(document.getElementById('gmap'), {
      zoom: 16,
      disableDefaultUI: true,
      center: location,
      styles: [
        {
          "featureType": "all",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "saturation": 0
            },
            {
              "color": "#ffffff"
            },
            {
              "lightness": 0
            }
          ]
        },
        {
          "featureType": "all",
          "elementType": "labels.text.stroke",
          "stylers": [
            {
              "visibility": "on"
            },
            {
              "color": "#000000"
            },
            {
              "lightness": 16
            }
          ]
        },
        {
          "featureType": "all",
          "elementType": "labels.icon",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "administrative",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": "#ff9c00"
            },
            {
              "lightness": 20
            }
          ]
        },
        {
          "featureType": "administrative",
          "elementType": "geometry.stroke",
          "stylers": [
            {
              "color": "#ff9c00"
            },
            {
              "lightness": 17
            },
            {
              "weight": 1.2
            }
          ]
        },
        {
          "featureType": "landscape",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#49525e"
            },
            {
              "lightness": 20
            }
          ]
        },
        {
          "featureType": "poi",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#ff9c00"
            },
            {
              "lightness": 21
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": "#ff9c00"
            },
            {
              "lightness": 17
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "geometry.stroke",
          "stylers": [
            {
              "color": "#ff9c00"
            },
            {
              "lightness": 29
            },
            {
              "weight": 0.2
            }
          ]
        },
        {
          "featureType": "road.arterial",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#ff9c00"
            },
            {
              "lightness": 10
            }
          ]
        },
        {
          "featureType": "road.local",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#ff9c00"
            },
            {
              "lightness": 50
            }
          ]
        },
        {
          "featureType": "transit",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#ff9c00"
            },
            {
              "lightness": 70
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#3e4095"
            },
            {
              "lightness": 17
            }
          ]
        }
    ]
    });

    let marker = new google.maps.Marker({
      position: location,
      map: map
    });
  }

  function pinHeader(isPinned) {
    let $header = $('.page-header');
    let $mainNavigation = $('.page-header .navigation');
    let hasClone = $('.page-header--pinned').length > 0;

    if (isPinned && !isMobile()) {
      if (hasClone) return;

      let $navigationClone = $mainNavigation.html();

      $header.after(`<div class="page-header page-header--pinned"><div class="container"><div class="navigation">${$navigationClone}</div></div></div>`);

      setTimeout(function() {
        $('.page-header--pinned').addClass('is-active');
      }, 100);
    } else {
      $('.page-header--pinned').removeClass('is-active');

      setTimeout(function() {
        $('.page-header--pinned').remove();
      }, 410);
    }
  }

  function toggleClassTimelineNav(index) {
    $('.timeline__nav-item').removeClass('is-active');
    $('.timeline__nav-item[data-index="'+index+'"').addClass('is-active');
  }

  function activeNewsScroller() {
    const $carousel = $('.lastest-news-scroller');
    if (isMobile(755)) {

      if(!$carousel.hasClass('slick-initialized')) {
        $carousel.slick({
          dots: true,
          arrows: false
        });
      }

    } else {
      if ($carousel.hasClass('slick-initialized')) {
        $carousel.slick('unslick');
      }
    }
  }

  function fieldNotEmpty(value) {
    value = value.trim();

    return value !== 'null' && value.length > 0;
  }

  function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    let regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    let results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  };

  function handleSearchButton() {
    const originValue = $('#origin').val();
    // const destinyValue = $('#destiny').val();
    const submitButton = $('.finder__form .button, .advanced-search .button');

    if (fieldNotEmpty(originValue)/* && fieldNotEmpty(destinyValue)*/) {
      submitButton.prop('disabled', false);
    } else {
      submitButton.prop('disabled', true);
    }
  }

  function fillOrigin() {
    const url = `${BASE_API}/origin?week_day=${$('#week_day').val()}`;

    if ($('#origin').length === 0) {
      return false;
    }

    $.ajax({
      url,
      beforeSend: function() {
        $('#origin').html('<option selected disabled>Aguarde</option>');
        $('#origin').chosen().trigger('chosen:updated');
      }
    }).done(function(response) {
      let option;

      for (let i = 0; i < response.length; i++) {
        option += `<option value="${response[i].id}">${response[i].name}</option>`;
      }

      $('#origin').html(option);
      $('#origin').chosen().trigger('chosen:updated');

      if (getUrlParameter('origin').length > 0) {
        const originId = getUrlParameter('origin');
        $('#origin').val(originId);
        $('#origin').trigger('chosen:updated');
      }
    })
    .fail(function(err) {
      console.log(err);
    });
  }

  function fillDestiny() {
    const url = `${BASE_API}/destiny?origin_stop=${$('#origin').val()}&week_day=${$('#week_day').val()}`;

    if ($('#destiny').length === 0) {
      return false;
    }

    $.ajax({
      url,
      beforeSend: function() {
        $('#destiny').html('<option selected disabled>Aguarde</option>');
        $('#destiny').chosen().trigger('chosen:updated');
      }
    }).done(function(response) {
      let option;

      if ($('#origin').val() !== '999999') {
        option = '<option selected value="">Todos os destinos</option>';
      }

      for (let i = 0; i < response.length; i++) {
        option += `<option value="${response[i].id}">${response[i].name}</option>`;
      }

      $('#destiny').html(option);
      $('#destiny').chosen().trigger('chosen:updated');

      if (getUrlParameter('destiny').length > 0) {
        const destinyId = getUrlParameter('destiny');
        $('#destiny').val(destinyId);
        $('#destiny').trigger('chosen:updated');
      }
    })
    .fail(function(err) {
      console.log(err);
    });
  }

  function toggleExpandable(triggerElement) {
    const parent = triggerElement.parent();
    const content = parent.find('.expandable__content');
    const innerContentHeight = parent.find('.expandable__content-inner').outerHeight();

    parent.toggleClass('is-active');

    if (parent.hasClass('is-active')) {
      content.css({'height': innerContentHeight});
    } else {
      content.css({'height': 0});
    }
  }

  function postTemplate(postContent) {
    return `
      <article class="post-listing post-listing--full">
        <div class="post-listing-inner">
          <p class="post-listing__meta">${postContent.formated_date}</p>
          <h4 class="post-listing__title"><a href="${postContent.link}">${postContent.title.rendered}</a></h4>
          <p class="post-listing__excerpt">${postContent.custom_excerpt}</p>
          <a href="${postContent.link}" class="post-listing__permalink">Leia mais <i class="icon-arrow-right"></i></a>
        </div>
      </article>
    `;
  }

  $(document).ready(function() {

    $('#contact-form').validate();
    $('.newsletter__form').validate();
    $('.phone-mask').mask(phoneMask, maskOptions);

    $(".chosen-select").chosen({
      disable_search_threshold: 10,
      no_results_text: 'Nenhum resultado encontrado!'
    });

    $('#origin').chosen().change(function() {
      handleSearchButton();
      fillDestiny();
    });

    $('#destiny').chosen().change(function() {
      handleSearchButton();
    });

    $('#week_day').chosen().change(function() {
      fillOrigin();
    });

    if ($('#week_day').val() !== null) {
      // fillOrigin();
    }

    if ($('#origin').val() !== null) {
      fillDestiny();
    }

    if ($('.expandable').length > 0) {
      toggleExpandable($('.expandable__trigger').first());
    }

    activeNewsScroller();

    if ($('#gmap').length > 0) {
      let coordinates = {
        lat: parseFloat($('#gmap').data('lat')),
        lng: parseFloat($('#gmap').data('lng'))
      };

      initMap(coordinates);
    }

    $('.expandable__trigger').click(function() {
      toggleExpandable($(this));
    });

    $('.home-ads-scroller').slick({
      dots: true,
      arrows: false
    });

    $('.post-carousel__inner').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
      {
        breakpoint: 950,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: true,
          arrows: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false
        }
      }
      ]
    });

    $('.timeline__carousel').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
      toggleClassTimelineNav(nextSlide);
    });

    $('.timeline__carousel').on('init', () => toggleClassTimelineNav(0));
    $('.timeline__carousel').slick({
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            arrows: false
        }
      }
    ]
    });

    $('.timeline__nav-item').click(function() {
      let index = $(this).data('index');
      toggleClassTimelineNav(index);
      $('.timeline__carousel').slick('slickGoTo', index);
    });

    $('.menu-trigger').click(function() {
      $(this).toggleClass('is-opened');
      $(this).next().toggleClass('is-opened');
    });

    $('.primary-menu').on('click', function(event) {
      if ($(this).is($(event.target)) && $(this).hasClass('is-opened')) {
        $('.menu-trigger').trigger('click');
      }
    });

    $('.advanced-search, .finder__form').on('submit', function(event) {
      if ($('#origin').val() === null/* || $('#destiny').val() === null*/) {
        event.preventDefault();
      }
    });

    $('.newsletter__form').submit(function(){
      var form = $(this);

      $.ajax({
        url: form.prop('action'),
        type: form.prop('method'),
        data: form.serialize(),
        beforeSend: function() {
          form.find('.loading').addClass('show');
        },
        success: function( data ){
          form.find('.loading').removeClass('show');

          $('.messages').html( $(data).filter('.messages').html() );
          $('.messages').slideDown('400');

          if( $(data).filter('.messages').find('.messages-success').length ){
            form[0].reset();
          }

          setTimeout(function() {
            $('.messages').slideUp('400');
          }, 5000);
        }
      });

      return false;
    });

    $('#contact-form').submit(function(e){
      e.preventDefault();
      const form = $(this),
      submitButton = form.find('button[type="submit"]')

      $.ajax({
          url: form.prop('action'),
          type: form.prop('method'),
          data: form.serialize(),
          beforeSend: function() {
            form.find('.loading').addClass('show');
            submitButton.prop('disabled', true);
          },
          success: function( data ){
            form.find('.loading').removeClass('show');
            submitButton.prop('disabled', false);

            $('.messages').html( $(data).filter('.messages').html() );
            $('.messages').slideDown('400');

            if( $(data).filter('.messages').find('.messages-success').length ){
                form[0].reset();
            }

            setTimeout(function() {
              $('.messages').slideUp('400');
            }, 5000);
          }
      });

      return false;
  });

  $('.js-load-more').click(function(e) {
    e.preventDefault();
    const $button = $(this);
    const page = $button.data('page') + 1;
    const url = `${BASE_API}/posts?per_page=3&page=${page}`;

    $.ajax({
      url,
      beforeSend: function() {
        $button.prev().addClass('show');
      }
    }).done(function(response) {
      $button.data('page', page);

      for (let i = 0; i < response.length; i++) {
        $('.lastest-news__list-inner').append(postTemplate(response[i]));
      }

      $('html, body').stop().animate({
        scrollTop: $('.post-listing').eq($('.post-listing').length - 3).offset().top - 150
      }, 1000);
    })
    .fail(function(err) {
      if (err.responseJSON.code === 'rest_post_invalid_page_number') {
        $button.fadeOut();
      } else {
        console.log(err);
      }
    })
    .always(function() {
      $button.prev().removeClass('show');
    });
  });

  });

  $(window).scroll(function() {
    ($(this).scrollTop() > 300 ) ? pinHeader(true) : pinHeader(false);
  });

  $(window).resize(function() {
    activeNewsScroller();
  });

})(jQuery);
